import { useSeoMeta } from '@unhead/react';
import { SatoshiTrail } from '@/components/game/SatoshiTrail';

const Index = () => {
  useSeoMeta({
    title: 'BCH Trail — A Bitcoin Cash Pioneer Adventure',
    description:
      'An Oregon Trail-inspired journey where you lead a wagon party across the frontier toward Freedom City, managing Bitcoin Cash, food, and health along the way.',
  });

  return <SatoshiTrail />;
};

export default Index;
